import { h } from 'preact';
import Videos from 'components/bolt/videos/videos';

import VideoPlayer from 'components/bolt/videos/player';
import VideosPlaylist from 'components/bolt/videos/playlist/playlist';
import { joinClasses } from 'utils/utils';

import s from 'components/videosOverlay/videosOverlay.sss';

export default class VideosOverlay extends Videos {

	constructor(props) {
		super(props);
		this.changeActiveVideoFromThumbnail = this.changeActiveVideoFromThumbnail.bind(this);
	}

	loadVideos() {
		this.setState({ 
			videos: this.props?.videos,
			loaded: true
		});
	}

	getLandingVideo() {
		const { loaded, videos, activeVideo } = this.state;
		if (!loaded) {
			return;
		}
		return activeVideo || videos[0];
	}

	changeActiveVideo(video) {
		this.setState({ activeVideo: video });
	}

	changeActiveVideoFromThumbnail(video) {
		this.props.trackVidThumbClick?.(video);
		this.changeActiveVideo(video);
	}

	handleEscapeKey(e) {
		if (e.keyCode === 27) {
			this.props.closeOverlay();
		}
	}

	onStartHandler() {
		const { activeVideo, videos } = this.state;
		const video = activeVideo || videos[0];
		this.changeActiveVideo(video);
		this.props.onWatchVideo?.(video);
	}

	onEndedHandler() {
		const { activeVideo } = this.state;
		const nextVideo = this.getNextVideo(activeVideo, this.state.videos);
		if (nextVideo) {
			this.changeActiveVideo(nextVideo);
		} else {
			this.props.closeOverlay();
		}
	}

	// unneeded methods from parent class
	findGalleryItemForQueryStringOrHash() {}
	scrollToQueriedVideo() {}
	


	render(props, state) {
		const activeVideo = state.activeVideo || this.getLandingVideo();
		let hidePlaylist = state.videos.length < 2;

		return (
			<div
				ref={ref => this.$container = ref}
				class={joinClasses(s.container)}
			>
				<VideoPlayer
					ref={e => this.$player = e}
					activeVideo={activeVideo}
					onEnded={this.onEndedHandler}
					onStart={this.onStartHandler}
					hiddenPlaylist={hidePlaylist}
				/>
				<VideosPlaylist
					ref={ref => this.$videosPlaylist = ref}
					videos={state.videos}
					activeVideo={activeVideo}
					changeActiveVideo={this.changeActiveVideoFromThumbnail}
					hidden={hidePlaylist}
				/>
			</div>
		);
	}
}
